import Vue from "vue";
import Router from "vue-router";
import storage from "store";

Vue.use(Router);

function load(path) {
  var ua = navigator.userAgent;
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  var isAndroid = ua.match(/(Android)\s+([\d.]+)/);
  var isMobile = isIphone || isAndroid;
  if (isMobile) {
    return () => import(`@/pages/mobile/${path}.vue`);
  }
  return () => import(`@/pages/web/${path}.vue`);
}

let routes = [];
let res = require.context("@/pages/web", true, /(.*).vue$/);
res.keys().forEach((key) => {
  let name = key.replace("./", "");
  name = name.replace(".vue", "");
  let vue = res(key).default;
  // console.log("key:", key);
  // console.log("name:", name);
  // console.log("vue:", vue);
  // console.log("----------------------------");

  let path = "/" + name;
  if (path == "/index") {
    path = "/";
  }
  routes.push({
    path,
    component: load(name),
    meta: vue.meta || {},
    ...vue.route,
  });
});

console.log("routes:", routes);

let router = new Router({
  base: "/",
  // mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  let meta = {
    auth: true,
  };

  meta = {
    ...meta,
    ...to.meta,
  };

  let token = storage.get("token");
  if (meta.auth && !token) {
    next("/login");
  }

  next();
});

export default router;
